import { render, staticRenderFns } from "./RpiHeaderDetails.vue?vue&type=template&id=5a3e6806"
import script from "./RpiHeaderDetails.vue?vue&type=script&lang=js"
export * from "./RpiHeaderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports